<template>
    <AxMultiSelect
        v-bind="attrs"
        :options="options"
        optionValue="id"
        optionLabel="label"
        fluid
    >
        <template #option="{ option }">
            <div class="flex w-full items-center justify-between">
                <span>
                    {{ option.label }}
                </span>
                <span class="text-gray-600">
                    {{ option.company }}
                </span>
            </div>
        </template>
    </AxMultiSelect>
</template>
<script setup lang="ts">
import { ref, useAttrs } from 'vue';
import { AxMultiSelect } from '@axxone-system/hades';

const props = defineProps<{ users: { name: string; id: number; company: string }[] }>();
const attrs = useAttrs();

const options = ref(
    props.users.map((user) => ({
        label: user.name + ' (' + user.company + ')',
        id: user.id!,
    })),
);
</script>
